import { cn } from 'lib/helpers/utility';

import { sheetMetrics } from './lib/docStyles';

const DocumentSheet = ({
  children,
  className,
  innerRef,
  fluid = false,
  fullWidth = false,
  landscape = false,
  style: styleProp,
  ...rest
}) => {
  const { sheetWidth, pageHeight } = sheetMetrics(landscape);

  const sizing = fluid
    ? fullWidth
      ? undefined
      : { maxWidth: sheetWidth }
    : { width: sheetWidth, height: pageHeight };

  const style = styleProp || sizing ? { ...sizing, ...styleProp } : undefined;

  return (
    <div
      ref={innerRef}
      style={style}
      className={cn(
        'bg-white px-12 pb-11 pt-12',
        fluid ? 'h-fit w-full xs:px-4 xs:py-6' : 'shrink-0 overflow-hidden',
        'print:max-w-full print:break-after-page print:last:break-after-auto',
        className
      )}
      {...rest}>
      {children}
    </div>
  );
};

export default DocumentSheet;
